require('./mortgageRequestManagerView.scss');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

// @ actions
const documentActions = require('actions/mortgageRequest/mortgageRequestDocumentationCenter');
const mortgageRequestTaxesInformationActions = require('actions/mortgageRequest/mortgageRequestTaxesInformation');
const collectivesActions = require('actions/collectives');

// @ commons
const { formatText } = require('core/i18n').i18n;
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');


// @ components
const { MortgageRequestManagerInfo } = require('components/mortgageRequest/mortgageRequestPanel/mortgageRequestManagerInfo/mortgageRequestManagerInfo');
const { MortgageRequestTargetDate } = require('components/mortgageRequest/mortgageRequestTarget/mortgageRequestTargetDate/mortgageRequestTargetDate');
const { MortgageRequestAddEmail } = require('components/mortgageRequest/mortgageRequestAddEmail/mortgageRequestAddEmail');
const { MortgageRequestPreapprovalPdf } = require('components/mortgageRequest/mortgageRequestPreapprovalPdf/mortgageRequestPreapprovalPdf');
const { CollectiveTag } = require('components/commons/collectiveTag/collectiveTag');
const MortgagesCollectiveTagTooltip = require('components/mortgagesCollectiveTagTooltip/mortgagesCollectiveTagTooltip');
const { MortgageRequestManagerDocuments } = require('components/mortgageRequest/mortgageRequestManagerDocuments/mortgageRequestManagerDocuments');

//@ constants
const DOCUMENTS_TYPES = require('constants/mortgageRequestDocumentsTypes');
const { MORTGAGE_PRODUCT_NUMBER } = require('constants/mortgageRequestType');
const mortgageRequestStates = require('constants/mortgageRequestStates');
const { MORTGAGE_TAXES_GROUP_CODE } = require('constants/index');
const { MORTGAGE_COLLECTIVE_PRODUCT_ALIAS, GENERIC_UI_COMPONENT_ID } = require('constants/mortgageRequestPreApproval').mortgageRequestPreApprovalCommons;

//@ helpers
const { getFinalTitle } = require('core/i18n').i18n;

//@ utilities
const {
    recordPath,
    PROC_START,
    PAGE_MORTGAGE_REQUEST,
} = require('utilities/tagging');

class MortgageRequestManagerView extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { requestDocument, immMortgageRequestState, getCollectiveInfo } = this.props;
        if (!!immMortgageRequestState && immMortgageRequestState.get('estado') === mortgageRequestStates.SOLIC_PRESTAMO) {
            requestDocument({
                'documentType': DOCUMENTS_TYPES.PRE_APROB,
                'notDownloadDocument': true,
                'idxDocument': 0
            });
        }
        getCollectiveInfo([{ alias: MORTGAGE_COLLECTIVE_PRODUCT_ALIAS }], GENERIC_UI_COMPONENT_ID);
        recordPath(`${PAGE_MORTGAGE_REQUEST}/${PROC_START}`);
    }

    UNSAFE_componentWillReceiveProps() {
        const { immMortgageData, immProfile, immTaxesInformation, taxesInformationRequest } = this.props;
        const productType = immMortgageData.getIn(['data', 'tipoProducto']);
        const term = immMortgageData.getIn(['data', 'plazo']);
        const productNumber = MORTGAGE_PRODUCT_NUMBER[productType];
        const taxesHasBeenFetched = immTaxesInformation.get('taxesHasBeenFetched');
        const taxesIsFetching = immTaxesInformation.get('isFetching');

        if (!taxesHasBeenFetched && !taxesIsFetching && !!productNumber && term !== 0) {
            const collectiveType = immProfile.get('collectiveType');
            const code3 = collectiveType.get('code3');
            const code4 = collectiveType.get('code4');
            const mortgageInfo = {
                type: productNumber,
                duration: term,
                code3,
                code4,
                groupCode: MORTGAGE_TAXES_GROUP_CODE
            };
            taxesInformationRequest(mortgageInfo);
        }
    }

    textContent() {
        const { immGlobalPosition } = this.props;
        const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");

        let textContent;

        if (isClientWithoutAccounts) {
            const guideProcess = formatText('mortgageRequestManagerInfo-guideProcess');
            const solveDoubts = formatText('mortgageRequestManagerInfo-solveDoubts');
            const stayWithYou = formatText('mortgageRequestManagerInfo-stayWithYou');
            const noCostForYou = formatText('mortgageRequestManagerInfo-noCostForYou');

            textContent = (
                <ul className="mortgage-request-manager-view__text__list">
                    <li>{guideProcess}</li>
                    <li>{solveDoubts}</li>
                    <li>{stayWithYou}</li>
                    <li>{noCostForYou}</li>
                </ul>
            );
        } else {
            const managerText = formatText('mortgageRequestManager-managerText');
            const managerWithOutCost = formatText('mortgageRequestManager-managerWithOutCost');

            textContent = (
                <div>
                    <p className="mortgage-request-manager-view__text--manager-user-info">{managerText}</p>
                    <p className="mortgage-request-manager-view__text--manager-no-cost-text">{managerWithOutCost}</p>
                </div>
            );
        }

        return textContent;
    }

    buildAddEmailContent() {
        const { immGlobalPosition } = this.props;
        const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");

        let addEmailContent;

        if (!isClientWithoutAccounts) {
            addEmailContent = (
                <div>
                    <hr />
                    <MortgageRequestAddEmail
                        isClientWithoutAccounts={isClientWithoutAccounts}
                    />
                </div>
            );
        }

        return addEmailContent;
    }

    buildContent() {
        const { immMortgageRequestState,
            mortgageRequestEstatesData,
            immMortgageData,
            immTaxesInformation,
            immGlobalPosition,
            requestDocument,
            flagBasedFeatures
        } = this.props;
        const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");
        const finalTitle = getFinalTitle('mortgageRequestManager-titleHeader');
        let content;

        // We show the manager content view only for the valid manager state (SOLIC_PRESTAMO)
        // This is to avoid an unnecessary load when we going to a different view
        if (!!immMortgageRequestState && immMortgageRequestState.get('estado') === mortgageRequestStates.SOLIC_PRESTAMO) {
            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-home'),
                    url: '/myprofile/'
                },
                {
                    text: formatText('navbar-loans'),
                    url: '/myprofile/loans-mortgages'
                },
                {
                    text: formatText('mortgageRequestManager-title'),
                    url: ''
                }
            ].filter((config, index) => (isClientWithoutAccounts && index > 1) || !isClientWithoutAccounts);

            const preApprovalPdfData = mortgageRequestEstatesData.get('documentData');
            const taxesHasBeenFetched = immTaxesInformation.get('taxesHasBeenFetched');
            const textContent = this.textContent();
            const addEmailContent = this.buildAddEmailContent();
            const title = !isClientWithoutAccounts
                ? formatText('mortgageRequestManagerInfo-yourManager')
                : formatText('mortgageRequestManagerInfo-yourManagerWithYou');

            let tooltipContent = '';

            if (taxesHasBeenFetched) {
                const immTaxes = immTaxesInformation.get('taxes');
                const mortgageType = immMortgageData.getIn(['data', 'tipoProducto']);
                const monthlyFee = immMortgageData.getIn(['data', 'cuotaMensual']);
                const tin = !!immTaxes.get('tin') ? immTaxes.getIn(['tin', 'fixed']) : '';
                const taxes = {
                    tin,
                    tae: immTaxes.get('tae'),
                    euribor: immTaxes.get('euribor')
                };
                tooltipContent = (
                    <MortgagesCollectiveTagTooltip
                        taxes={taxes}
                        mortgageType={mortgageType}
                        monthlyFee={monthlyFee}
                    />
                );
            }

            content = (
                <div className="mortgage-request-manager-view">
                    <OKCover size="medium" section="loansmortgages">
                        <OKHeaderSubPage
                            breadcrumbConfig={mappingBreadcrumb}
                            finalTitle={finalTitle}
                        />
                    </OKCover>
                    <div className="mortgage-request-manager-view__body panel-body">
                        <div className="col-xs-12 col-md-8">
                            <div className="row">
                                <MortgageRequestTargetDate
                                    isClientWithoutAccounts={isClientWithoutAccounts}
                                />
                                <MortgageRequestPreapprovalPdf
                                    pdfBase64={preApprovalPdfData.get('base64')}
                                    contentType={preApprovalPdfData.get('contentType')}
                                    fileName={preApprovalPdfData.get('filename')}
                                    isClientWithoutAccounts={isClientWithoutAccounts}
                                />
                                <MortgageRequestManagerDocuments
                                    isClientWithoutAccounts={isClientWithoutAccounts}
                                    requestDocument={requestDocument}
                                    flagBasedFeatures={flagBasedFeatures}
                                    immMortgageRequestState={immMortgageRequestState}
                                />
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-4">
                            <ContentBox>
                                <CollectiveTag
                                    extraClass={"mortgage-request-manager-view__body__collective-tag"}
                                    productAlias={MORTGAGE_COLLECTIVE_PRODUCT_ALIAS}
                                    tooltipContent={tooltipContent}
                                />
                                <div className="mortgage-request-manager-view__body__manager-title">
                                    <OKBoxTitle
                                        value={title}
                                        size="medium"
                                        isNotSeparator
                                    />
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <p className="mortgage-request-manager-view__text">
                                            {textContent}
                                            <hr />
                                        </p>
                                    </div>
                                </div>
                                <MortgageRequestManagerInfo compact={false} />
                                {addEmailContent}
                            </ContentBox>
                        </div>
                    </div>
                </div>
            );
        } else {
            content = <LoadingSection />;
        }

        return content;
    }

    render() {
        return this.buildContent();
    }
}

MortgageRequestManagerView.propTypes = {
    immGlobalPosition: PropTypes.object.isRequired,
    requestDocument: PropTypes.func,
    mortgageRequestEstatesData: PropTypes.object,
    immLoan: PropTypes.object,
    immProfile: PropTypes.object,
    immMortgageData: PropTypes.object,
    taxesInformationRequest: PropTypes.func,
    immTaxesInformation: PropTypes.object,
    immMortgageRequestState: PropTypes.object,
    getCollectiveInfo: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object
}

module.exports.constructor = MortgageRequestManagerView;

module.exports.MortgageRequestManagerView = connect(
    state => ({
        mortgageRequestEstatesData: state.mortgageRequestEstatesData,
        immMortgageData: state.mortgageRequestMortgageData,
        immTaxesInformation: state.mortgageRequestTaxesInformation,
        immLoan: state.loans,
        immProfile: state.profile,
        immMortgageRequestState: state.mortgageRequestState,
        flagBasedFeatures: state.flagBasedFeatures,
        immGlobalPosition: state.globalPosition,
    }),
    {
        requestDocument: documentActions.getDocument,
        taxesInformationRequest: mortgageRequestTaxesInformationActions.taxesInformationRequest,
        getCollectiveInfo: collectivesActions.getCollectiveInfo
    }
)(MortgageRequestManagerView);
